module.exports = __webpack_public_path__ + "static/media/socialLogin_with_firebase.a0d914f1.PNG";